export const buildMonthlyAvailabilityReport = (monthlyCounters) => {
  if (!monthlyCounters || Object.keys(monthlyCounters).length === 0) {
    return null;
  }

  const volunteers = Object.entries(monthlyCounters)
    .map(([id, info]) => ({
      id: parseInt(id, 10),
      nome: info?.nome || "",
      cognome: info?.cognome || "",
      disponibilitaTotali: parseInt(info?.disponibilita_totali || 0, 10),
      assegnazioniTotali: parseInt(info?.assegnazioni_totali || 0, 10),
      indisponibileMese: Boolean(info?.indisponibile_mese),
    }))
    .filter((volunteer) => !Number.isNaN(volunteer.id))
    .sort((a, b) => {
      const surnameCompare = a.cognome.localeCompare(b.cognome, "it", {
        sensitivity: "base",
      });
      if (surnameCompare !== 0) return surnameCompare;
      return a.nome.localeCompare(b.nome, "it", { sensitivity: "base" });
    });

  const unavailableForMonth = volunteers.filter(
    (volunteer) => volunteer.indisponibileMese
  );

  const zeroAvailabilityUnassigned = volunteers.filter(
    (volunteer) =>
      !volunteer.indisponibileMese &&
      volunteer.disponibilitaTotali === 0 &&
      volunteer.assegnazioniTotali === 0
  );

  const availableButUnassigned = volunteers.filter(
    (volunteer) =>
      !volunteer.indisponibileMese &&
      volunteer.disponibilitaTotali > 0 &&
      volunteer.assegnazioniTotali === 0
  );

  const assignedSuccessfully = volunteers.filter(
    (volunteer) =>
      !volunteer.indisponibileMese && volunteer.assegnazioniTotali > 0
  );

  return {
    zeroAvailabilityUnassigned,
    availableButUnassigned,
    unavailableForMonth,
    assignedSuccessfullyCount: assignedSuccessfully.length,
    totalVolunteers: volunteers.length,
  };
};
